import { config } from "./../constant";
export default {
  assetVerificationGroupReorder:
    config.url.API_URL + "asset-verification-attribute-group/reorder",
  assetVerificationAttributesReorder:
    config.url.API_URL + "asset-verification-attribute/reorder",
  conventReviewReorder: config.url.API_URL + "covenant/reorder",
  assetTapeDetails: "asset-tape",
};
